import React, { FC, useEffect } from 'react';
import { ESocketEvent, EUserRole } from 'common/const/enum';
import { useAppDispatch, useAppSelector, useSocket } from 'common/hooks';
import { getFormattedTime } from 'common/helpers';
import { StatisticsPanelItem } from 'entities/Statistics/components';

export const StatisticsPanel: FC = () => {
  const { auth, statistics, watchUpdates } = useAppSelector((state) => ({
    auth: state.auth.data,
    statistics: state.statistics.data,
    watchUpdates: state.statistics.watchUpdates,
  }));
  const { statistics: statisticsDispatch } = useAppDispatch();

  const role = auth?.access?.rights?.[0];

  useEffect(() => {
    if (role) {
      statisticsDispatch.getStatistics(role);
    }
  }, [role]);

  useSocket(
    ESocketEvent.Events,
    () => {
      if (role && watchUpdates) {
        statisticsDispatch.getStatistics(role);
      }
    },
    [watchUpdates],
  );

  if (!statistics) {
    return null;
  }

  return (
    <div className="mb-7 statistics-panel">
      {role === EUserRole.Staff ? (
        <StatisticsPanelItem title="In Queue" value={statistics.pendingCount} />
      ) : (
        <StatisticsPanelItem title="My pending events" value={statistics.pendingCount} />
      )}

      <StatisticsPanelItem
        title={
          <>
            Completed <br />
            for today
          </>
        }
        value={statistics.completedTodayCount}
      />

      <StatisticsPanelItem
        title={
          <>
            Total review time <br />
            for today
          </>
        }
        value={getFormattedTime(statistics.totalTimeToday, 'HH:mm:ss')}
        background="blue"
      />
    </div>
  );
};
